import React, { useEffect, useState } from 'react';
import { FiStar } from 'react-icons/fi';
import Achievements from '../AboutUs/Achievements';
import SisterConcerms from '../AboutUs/SisterConcerms';
import AboutBanner from '../AboutUs/AboutBanner';

// Iconic Unity Group Testimonials Data
const testimonialsData = [
  {
    title: "A Platform That Encourages Entrepreneurship",
    text: "Iconic Unity Group is creating a unique business ecosystem where entrepreneurs receive strategic guidance, professional support, and the opportunity to build sustainable businesses under one trusted platform.",
    author: "Business Partner",
    company: "Entrepreneurship & Ecosystem",
    rating: 5,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150"
  },
  {
    title: "Innovation with a Long-Term Vision",
    text: "What impressed us most is IUG's commitment to innovation, transparency, and sustainable growth. Their vision goes beyond business—they are building opportunities for future entrepreneurs.",
    author: "Strategic Partner",
    company: "Innovation & Growth",
    rating: 5,
    image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150"
  },
  {
    title: "Professionalism You Can Trust",
    text: "Their structured business approach, strong corporate governance, and commitment to excellence make Iconic Unity Group a reliable business partner for long-term collaboration.",
    author: "Corporate Associate",
    company: "Governance & Excellence",
    rating: 5,
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150"
  },
  {
    title: "Building Businesses Together",
    text: "IUG believes in collaboration rather than competition. Their partnership model creates confidence and provides businesses with the support they need to grow successfully.",
    author: "Venture Partner",
    company: "Strategic Partnerships",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150"
  },
  {
    title: "Committed to Economic Development",
    text: "By supporting entrepreneurs and creating employment opportunities, Iconic Unity Group is making a meaningful contribution to economic and social development.",
    author: "Industry Observer",
    company: "Socio-Economic Impact",
    rating: 5,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150"
  }
];

const Testimonials = () => {


  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  return (
    <div style={{ fontFamily: "'Inter', sans-serif", background: '#f8fafc' }}>
      {/* Banner */}
      <AboutBanner
        text="Testimonials"
        des="At Iconic Unity Group, we believe that trust is earned through integrity, innovation, and long-term commitment. Hear directly from the partners and collaborators who build the future with us."
      />

      <div className="about-us-section" style={{ paddingTop: '0px', paddingBottom: '60px' }}>
        <section id="testimonials" className="testimonials-section">
          <div className="testimonials-container" style={{ maxWidth: '1440px', margin: '0 auto' }}>

            {/* Header Section */}
            <div style={{ textAlign: 'center', marginBottom: '50px' }}>
              <span style={{
                fontSize: '0.875rem',
                fontWeight: '700',
                color: '#00afe9',
                letterSpacing: '1.5px',
                textTransform: 'uppercase',
                display: 'block',
                marginBottom: '8px'
              }}>
                What People Say About Us
              </span>
              <h2 style={{ fontSize: isMobile ? "1.5rem" : '2.25rem', fontWeight: '800', color: '#0f172a', marginBottom: '16px', textTransform: "uppercase", }}>
                Trusted by Partners & Visionaries
              </h2>
              <p style={{ maxWidth: isMobile ? "" : '750px', margin: '0 auto', color: '#475569', fontSize: '1.05rem', lineHeight: '1.7' }}>
                As we continue to grow, our greatest achievement is building meaningful relationships with our customers, partners, and entrepreneurs.
              </p>
            </div>

            {/* Testimonials Grid */}
            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: '24px',
              marginBottom: isMobile ? "30px" : '60px'
            }}>
              {testimonialsData.map((test, i) => (
                <div
                  key={i}
                  style={{
                    flex: '1 1 calc(33.333% - 24px)',
                    minWidth: '300px',
                    maxWidth: '380px',
                    backgroundColor: '#ffffff',
                    padding: '32px 24px',
                    borderRadius: '16px',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = 'translateY(-6px)';
                    e.currentTarget.style.boxShadow = '0 12px 20px -3px rgba(0, 0, 0, 0.08)';
                    e.currentTarget.style.borderColor = '#00afe9';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.05)';
                    e.currentTarget.style.borderColor = '#e2e8f0';
                  }}
                >
                  <div>
                    {/* Rating Stars */}
                    <div style={{ display: 'flex', gap: '4px', color: '#f59e0b', marginBottom: '16px' }}>
                      {[...Array(test.rating)].map((_, idx) => (
                        <FiStar key={idx} fill="currentColor" size={18} />
                      ))}
                    </div>

                    {/* Title */}
                    <h4 style={{ fontSize: '1.1rem', fontWeight: '700', color: '#0f172a', marginBottom: '12px', lineHeight: '1.4' }}>
                      "{test.title}"
                    </h4>

                    {/* Quote Text */}
                    <p style={{ fontSize: '0.95rem', color: '#475569', lineHeight: '1.65', marginBottom: '24px', fontStyle: 'italic' }}>
                      "{test.text}"
                    </p>
                  </div>

                  {/* Author Information */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '14px', paddingTop: '16px', borderTop: '1px solid #f1f5f9' }}>
                    <div style={{ width: '48px', height: '48px', borderRadius: '50%', overflow: 'hidden', flexShrink: 0, border: '2px solid #e0f2fe' }}>
                      <img
                        src={test.image}
                        alt={test.author}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                    </div>
                    <div>
                      <h5 style={{ fontSize: '1rem', fontWeight: '700', color: '#0f172a', margin: 0 }}>
                        {test.author}
                      </h5>
                      <p style={{ fontSize: '0.85rem', color: '#00afe9', fontWeight: '500', margin: 0 }}>
                        {test.company}
                      </p>
                    </div>
                  </div>

                </div>
              ))}
            </div>

            <section
              style={{
                maxWidth: "1440px",
                margin: "0px auto",
                padding: isMobile ? "0px 0px" : "0px 60px",
                textAlign: "center",
                paddingBottom: "40px",
              }}
            >
              <span
                style={{
                  display: "inline-block",
                  color: "#000000",
                  fontSize: isMobile ? "1.6rem" : "2rem",
                  fontWeight: "700",
                  letterSpacing: "2px",
                  paddingBottom: isMobile ? "20px" : "",
                  textTransform: "uppercase",


                }}
              >
                Our Commitment
              </span>

              <blockquote
                style={{
                  fontSize: isMobile ? "1rem" : "1.35rem",
                  fontWeight: "500",
                  lineHeight: "1.9",
                  color: "#334155",
                  margin: "0",

                }}
              >
                “The trust of our partners, customers, and entrepreneurs inspires us to continue building businesses that create opportunities, empower communities, and shape a better future.”
              </blockquote>
            </section>

          </div>
        </section>

        {/* Achievements Section */}
        <Achievements />

        {/* Sister Concerns Section */}
        <SisterConcerms />
      </div>
    </div>
  );
};

export default Testimonials;